export default __webpack_public_path__ + "static/media/christian_&_gospel.6774f773.png";